// extracted by mini-css-extract-plugin
module.exports = {"btn":"btn-pri_btn__3cJWF","containerBtn":"btn-pri_containerBtn__wpM4I"};